import { gql } from '@apollo/client';

import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const assessmentStimulusFragment = gql`
  fragment AssessmentStimulusFragment on Assessment {
    id
    stimulusResources {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const GET_ASSESSMENT_BY_ID = gql`
  query GetStimulusAssessmentById($input: GetAssessmentByIdInput!) {
    getAssessmentById(input: $input) {
      id
      stimulusResources {
        ...StimulusResource
      }
    }
  }
  ${stimulusResourceFragment}
`;
